import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { loadGA } from "@/lib/analytics";

const KEY = "opera_cookie_consent";

export function CookieConsent() {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));

  useEffect(() => {
    if (choice === "accepted") loadGA();
  }, [choice]);

  if (choice) return null;

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setChoice(value);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-[#091623] border-t border-[#C5A059]/30 shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col lg:flex-row items-start lg:items-center gap-5">
        <Cookie className="text-[#C5A059] shrink-0" size={26} strokeWidth={1.5} />
        <p className="text-sm text-gray-300 leading-relaxed flex-1">
          Utilizziamo cookie tecnici necessari e, previo consenso, cookie di misurazione (Google
          Analytics) per capire come viene usato il sito. Puoi accettare o rifiutare. Maggiori
          dettagli nella{" "}
          <Link to="/cookie" className="text-[#C5A059] underline underline-offset-2">
            Cookie Policy
          </Link>
          .
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-reject"
            onClick={() => decide("rejected")}
            className="border border-white/20 text-gray-200 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors text-sm font-medium px-5 py-2.5"
          >
            Rifiuta
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="bg-[#C5A059] text-[#0D1B2A] hover:bg-[#D8B978] transition-colors text-sm font-medium px-6 py-2.5"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
